import { Box, IconButton } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useState } from 'react';

const LiteYoutubePreview = ({ videoId, width = '100%', height = 'auto' }) => {
    const [loaded, setLoaded] = useState(false);

    if (!videoId) return null;

    const thumbnail = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    const fallbackThumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&rel=0`;

    return (
        <Box
            position="relative"
            width={width}
            height={height}
            sx={{
                overflow: 'hidden',
                borderRadius: 2,
            }}
        >
            {!loaded ? (
                <Box
                    component="img"
                    src={thumbnail}
                    alt="YouTube preview"
                    sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block',
                        cursor: 'pointer',
                    }}
                    onClick={() => setLoaded(true)}
                    onError={(e) => {
                        // Si la imagen HD no existe, usar la de alta calidad como fallback
                        if (e.target.src !== fallbackThumbnail) {
                            e.target.src = fallbackThumbnail;
                        }
                    }}
                />
            ) : (
                <iframe
                    src={embedUrl}
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 0,
                    }}
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                    title="YouTube video"
                />
            )}

            {!loaded && (
                <IconButton
                    onClick={() => setLoaded(true)}
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        color: 'white',
                        '&:hover': {
                            backgroundColor: 'rgba(0,0,0,0.8)',
                        },
                    }}
                >
                    <PlayArrowIcon fontSize="large" />
                </IconButton>
            )}
        </Box>
    );
};

export default LiteYoutubePreview;
